import mitt from 'mitt';

// Create a mitt event emitter
const emitter = mitt();

export default emitter; 